<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="ahalf1" title="Half Title">
<p class="halftitle"><span class="right_1" epub:type="pagebreak" id="page_xxv" title="xxv">THE WISCONSIN ONEIDAS AND</span></p>
<p class="halftitle0">THE EPISCOPAL CHURCH<span class="right_1" epub:type="pagebreak" id="page_xxvi" title="xxvi"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253041401_Halftitle_1.vue?74e19504